import * as Yup from 'yup';

export const rateioTemplateSchema = Yup.object().shape({
  descricao: Yup.string()
    .required('Descrição é obrigatória')
    .min(3, 'Mínimo 3 caracteres')
    .max(100, 'Máximo 100 caracteres'),
  obs: Yup.string()
    .nullable()
    .max(4000, 'Máximo 4000 caracteres'),
  contas: Yup.array()
    .of(
      Yup.object().shape({
        departamento: Yup.number()
          .required('Departamento obrigatório')
          .positive('Departamento inválido')
          .integer(),
        descricao_depto: Yup.string(),
        percentual: Yup.number()
          .typeError('Percentual deve ser um número')
          .required('Percentual obrigatório')
          .positive('Percentual deve ser maior que zero')
          .max(100, 'Percentual não pode ultrapassar 100'),
      })
    )
    .test(
      'soma-valida',
      'Soma dos percentuais não pode ultrapassar 100%',
      (contas = []) =>
        contas.reduce((s, c) => s + (Number(c.percentual) || 0), 0) <= 100.0001
    )
    .test(
      'deptos-unicos',
      'Departamento duplicado na lista',
      (contas = []) => {
        const ids = contas.map((c) => c.departamento);
        return new Set(ids).size === ids.length;
      }
    ),
});
